import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const checkboxStyle = css`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  color: ${theme.color.text};
  font-size: ${theme.fontSize.md}px;
  cursor: pointer;

  input {
    accent-color: ${theme.color.primary};
  }
`;
